import React, { ComponentType, useState } from "react";
import { Create } from "./Pages/Create";
import { Normal } from "./Pages/Normal";
import { Leave } from "./Pages/Leave";
import styled from "styled-components";
import {VoiceSettings} from "./Pages/VoiceSettings";

const Styles = {
	Frame: styled.div`
		display: flex;
	`,
	Entry: styled.div<{ $focus: boolean}>`
		padding: 10px 20px;
		border-bottom: 1px solid rgb(240, 138, 69);
		color: ${ p => p.$focus ? 'white' : 'rgb(240, 138, 69)' };
		background: #32190D;
		cursor: pointer;
		transition: background 0.2s ease-in-out;
		&:hover {
            border-bottom: 1px solid rgb(240, 138, 69);
		}
	`
};

export const _SquadTabs = {
	create: { tag: "create", text: "Einrichtung", component: Create },
	normal: { tag: "normal", text: "Taktische Ansicht", component: Normal },
	voice: { tag: "voice", text: "Voice", component: VoiceSettings },
	leave: { tag: "leave", text: "Verlassen", component: Leave },
} as Record<string, { tag: string; component: ComponentType, text: string }>;

export const SquadTabs = () => {

	const [status, setStatus] = useState<string>(_SquadTabs.create.tag);

	const handles = {
		onClickTab: (tag: string) => {
			setStatus(tag);
		}
	}
	const Component = _SquadTabs[status]?.component;

	return <>
		<Styles.Frame>{
			Object.values(_SquadTabs).map((tab) =>
				<Styles.Entry $focus={status === tab.tag}
				              onClick={() => handles.onClickTab(tab.tag)}>{tab.text}</Styles.Entry>)
		}</Styles.Frame>
		{ Component ? <Component/> : <div/> }
	</>
}
